import {
  PATH_DATA_USAGE,
  PATH_DATA_PERSON,
  PATH_DATA_WEEK,
  PATH_DATA_ACTIVATION
} from "@/constants/URL";

import routerWithSidebar from "./routerWithSidebar";

export default {
  path: PATH_DATA_USAGE,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_DATA_USAGE,
      name: "usage",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/data/usage/index.vue")
      )
    },
    {
      path: PATH_DATA_PERSON,
      name: "person",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/data/person/index.vue")
      )
    },
    {
      path: PATH_DATA_WEEK,
      name: "week",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/data/week/index.vue")
      )
    },
    {
      path: PATH_DATA_ACTIVATION,
      name: "activation",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/data/activation/index.vue")
      )
    }
  ]
};
